__webpack_require__.p = "/tur_virtual/DepoulVatraLuminoasa/_next/";